import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { Button } from "../../components/button/Button";
import Loader from "../../components/styled-components/loader/loader";
import DEATH_API from "../../apis/death.api";
import { useDispatch, useSelector } from "react-redux";
import { setActivated } from "../../redux/slices/loginSlice";
import swal from "sweetalert";
import axios from "axios";
import ROUTES from "../../config/routes";

const DelegateAccess = () => {
  const activated = useSelector(
    (state) => state.rootReducer.loginUser.activated
  );
  console.log("activated", activated);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [trusteeList, setTrusteeList] = useState([]);
  const [inviteList, setInviteList] = useState([]);

  useEffect(() => {
    getClientList();
    if((JSON.parse(localStorage.getItem("role")) === "activeClient") || (JSON.parse(localStorage.getItem("role")) === "activeClient")){
      getContactList();
    }
  }, []);
  const getClientList = async () => {
    try {
        setLoading(true);
        let responseData = await DEATH_API.fetchClientList();
        let newData = [];
        if (
          responseData.data &&
          responseData.data[0] &&
          responseData.data[0].users
        ) {
          newData = responseData.data[0].users;
          // console.log("newData",newData)
          newData.map((item, index) => (item["Status"] = false));
        }
        localStorage.setItem("delegateUsers", JSON.stringify(newData));
        if (
          responseData.data &&
          responseData.data[0] &&
          responseData.data[0].invitedBy
        ) {
          setInviteList(responseData.data[0].invitedBy);
        }
        setLoading(false);
        if (isNaN(localStorage.getItem("User"))) {
          console.log("not a number in username");
          // getContactList();
        }
    } catch (error) {
      setLoading(false);
      console.log("error");
    }
  };
  const getContactList = async () => {
    try {
      setLoading(true);
      let apiResponse = await DEATH_API.getPeopleWithAccess();
      console.log("apiResponse", apiResponse);
      setTrusteeList([]);
      if (apiResponse && apiResponse.invited &&  apiResponse.invited[0] && apiResponse.invited[0].contacts) {
        setTrusteeList(apiResponse.invited[0].contacts);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const deleteTrusteeAccess = async (id, trusteeId) => {
    let payload={
      contactId:id,
      trusteeId:trusteeId
    }
    swal({
      title: "Are you sure?",
      text: "You want to delete this Trustee.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then( async(willDelete) => {
      if (willDelete) {
        try {
          setLoading(true);
           const resposnse= await DEATH_API.cancelTrusteeAccess(payload);
           if(resposnse && resposnse.status===200){
             await getContactList();
             swal("Success",resposnse.message,"success");
           }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled","Your Trustee is safe :)","error");
      }
    });

    // try {
    //   setLoading(true);
    //    const resposnse= await DEATH_API.cancelTrusteeAccess(payload);
    //    if(resposnse && resposnse.status===200){
    //      await getContactList();
    //    }
    //   setLoading(false);
    // } catch (error) {
    //   console.log(error);
    //   setLoading(false);
    // }
  };


  const [accessableUsers, setAccessableUsers] = useState([]);
  const users =
    localStorage.getItem("delegateUsers") !== "undefined" &&
    JSON.parse(localStorage.getItem("delegateUsers"));

  // console.log("users", users)
  useEffect(() => {
    // Perform localStorage action
    // const users = JSON.parse(localStorage.getItem("delegateUsers"))
    // console.log("users", users)
   
    getClientList();
    const users =
      localStorage.getItem("delegateUsers") !== "undefined" &&
      JSON.parse(localStorage.getItem("delegateUsers"));
    console.log("useEffect activated", activated);
    setAccessableUsers(users);
  }, [activated]);

  const handleClick = (id) => {
    console.log("id", id);
    users.map((item, index) => {
      if (id == item.id) {
        console.log("here");
        item["Status"] = true;
        localStorage.setItem("delegateUsers", JSON.stringify(users));
      } else {
        item["Status"] = false;
      }
    });
    // console.log("accessableUsers", accessableUsers)
    // dispatch(setActivated(!activated))
  };
  const handleAccept = async (code) => {
    console.log("Accepted");
    try {
      setLoading(true);
      let responseData = await DEATH_API.acceptInvitation(code);
      console.log("responseData", responseData);
      if (responseData && responseData.status === 200) {
        swal("Success", responseData.message, "success");
        await getClientList();
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error");
    }
  };

  return (
    <div>
      <div className="asset-heading" style={{ background: "#2A3DA3" }}>
        <Row style={{ textAlign: "center" }}>
          <div>
            <h2 style={{ color: "white" }} className=" font-weight">
              Delegate Access
            </h2>
          </div>
        </Row>
      </div>
      <Row style={{ textAlign: "center" }}>
        {((localStorage.getItem("duplicateRole") &&
          JSON.parse(localStorage.getItem("duplicateRole")) ===
            "activeClient") ||
          JSON.parse(localStorage.getItem("role")) === "activeClient") && (
          <Button
            style={{ width: "30%", background: "#2A3DA3" }}
            onClick={() => {
              console.log("My account");
              if (localStorage.getItem("accessId")) {
                localStorage.removeItem("accessId");
              }
              if (localStorage.getItem("duplicateRole")) {
                localStorage.setItem(
                  "role",
                  localStorage.getItem("duplicateRole")
                );
              }
              getClientList();
              dispatch(setActivated(!activated));
            }}
          >
            My Account
          </Button>
        )}
      </Row>
      {/*
            <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-around" }}>

                {trusteeList && trusteeList.map((item, index) => (
                    <Col key={index} style={{ width: "30%" }} className='DelegateCard' >
                        <div
                            className='DelegateClientSection'
                        >
                            <p className='DelegateHeading'>{item.firstName} + {item.lastName}</p>
                        </div>
                        <div
                            className='DelegateClientSection'
                        >
                            <p className='DelegateHeading'>Module I Can Access</p>
                        </div>
                        <p className='DelegateSubHeading'>Asset</p>
                        <p className='DelegateSubHeading'>Liabilities</p>
                        <p className='DelegateSubHeading'>If I Die</p>
                        <div
                            className='DelegateClientSection'
                        >
                            <Button style={{ width: "80%" }}>Edit Access</Button>
                        </div>
                    </Col>

                ))}
            </div>
        */}
      <Row gutter={[16, 16]} className="RowContainer" style={{justifyContent:"space-between"}}>
        {/* LEFT BOX */}
        <Col xs={24} sm={12} lg={12} xl={12} style={{ display: "flex", width:"45%" }}>
          <Row className="DelegateSection">
            <Col style={{ height: "auto" }}>
              <p className="left-black">People With Access to My Account</p>
            </Col>
            {trusteeList &&
              trusteeList.map(
                (item, index) =>
                  item.isTrusted && (
                    <Col key={index} className="DelegateCard">
                      <div className="DelegateClientSection">
                        <p className="DelegateHeading">
                          {item.firstName ? item.firstName :"" } {item.lastName ? item.lastName :""}
                        </p>
                      </div>
                      <div className="DelegateClientSection">
                        <p className="DelegateHeading">
                          Module I have Granted Access
                        </p>
                      </div>
                      <p className="DelegateSubHeading" style={{ margin: "2rem 2rem" }}>Death (When I Die)</p>
                      <div
                        style={{ marginTop: "8px" }}
                        className="DelegateClientSection"
                      >
                        <p
                          style={{
                            fontWeight: "500",
                            fontSize: "18px",
                            color: "green",
                          }}
                        ></p>
                         <Button style={{ width: "fit-content", background: "#E65E42" }} 
                         onClick={() => {
                          if(item.invites && item.invites[0] && item.invites[0].trusteeUserId){
                            deleteTrusteeAccess(item.id, item.invites[0].trusteeUserId)
                            }
                           }}
                           >Cancel Now
                           </Button>
                      </div>
                    </Col>
                  )
              )}
          </Row>
        </Col>

        {/* RIGHT BOX */}
        <Col xs={24} sm={12} lg={12} xl={12} style={{ display: "flex",width:"45%" }}>
          <Row className="DelegateSection">
            <Col style={{ height: "auto" }}>
              <p className="left-black">Accounts I Have Access To</p>
            </Col>
            {users &&
              users.map((item, index) => (
                <Col key={index} className="DelegateCard">
                  <div className="DelegateClientSection">
                    <p className="DelegateHeading">{item.name}</p>
                  </div>
                  <div className="DelegateClientSection">
                    <p className="DelegateHeading">Modules I Can Access</p>
                  </div>
                  <p
                    className="DelegateSubHeading"
                    style={{ margin: "2rem 2rem" }}
                  >
                    Death (When I Die)
                  </p>
                  <div
                    className="DelegateClientSection"
                    style={{ marginTop: "8px" }}
                  >
                    {!item.Status ? (
                      item.id == localStorage.getItem("accessId") ? (
                        <p
                          style={{
                            fontWeight: "500",
                            fontSize: "18px",
                            color: "green",
                          }}
                        >
                          Activated
                        </p>
                      ) : (
                        <Button
                          style={{ width: "fit-content", background: "#2A3DA3" }}
                          onClick={() => {
                            // console.log("client id", item.trusteeUser[0].role.name)
                            handleClick(item.id);
                            localStorage.setItem("accessId", item.id);
                            if (
                              JSON.parse(localStorage.getItem("role")) ==
                                "test111" ||
                              JSON.parse(localStorage.getItem("role")) ==
                                "activeClient" ||
                              JSON.parse(localStorage.getItem("role")) ==
                                "protrustee" ||
                              JSON.parse(localStorage.getItem("role")) ==
                                "trustee"
                            ) {
                              console.log("here in client side");
                              if (!localStorage.getItem("duplicateRole")) {
                              localStorage.setItem(
                                "duplicateRole",
                                localStorage.getItem("role")
                              );
                              }
                              // console.log("item.role", item.trusteeUser[0].role.name);
                              if (
                                item.trusteeUser &&
                                item.trusteeUser[0] &&
                                item.trusteeUser[0].role
                              ) {
                                localStorage.setItem(
                                  "role",
                                  JSON.stringify(item.trusteeUser[0].role.name)
                                );
                              }
                            }

                            dispatch(setActivated(!activated));
                            getClientList();
                          }}
                          
                          
                        >
                          Access Now
                        </Button>
                      )
                    ) : (
                      <p
                        style={{
                          fontWeight: "500",
                          fontSize: "18px",
                          color: "green",
                        }}
                      >
                        Activated
                      </p>
                    )}
                  </div>
                </Col>
              ))}
            {inviteList &&
              inviteList.map((item, index) => (
                <Col
                  key={index}
                  className="DelegateCard"
                  style={{ height: "fit-content" }}
                >
                  <div className="DelegateClientSection">
                    <p className="DelegateHeading">{item.name}</p>
                  </div>
                  <div className="DelegateClientSection">
                    <p className="DelegateHeading">Modules I Can Access</p>
                  </div>
                  <p
                    className="DelegateSubHeading"
                    style={{ margin: "2rem 2rem" }}
                  >
                    Death (When I Die)
                  </p>
                  <div
                    className="DelegateClientSection"
                    style={{
                      marginTop: "8px",
                      gap: "1rem",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      style={{ width: "fit-content", background: "#09A84D" }}
                      onClick={() => {
                        if (
                          item.contacts &&
                          item.contacts[0] &&
                          item.contacts[0].invites &&
                          item.contacts[0].invites[0] &&
                          item.contacts[0].invites[0].invititationCode
                        ) {
                          handleAccept(
                            item.contacts[0].invites[0].invititationCode
                          );
                        }
                      }}
                    >
                      Accept Invite
                    </Button>
                    <Button
                      style={{
                        width: "fit-content",
                        background: "#2A3DA3",
                        opacity: "0.5",
                        cursor: "not-allowed",
                        // pointerEvents:"none"
                      }}
                    >
                      Access Now
                    </Button>
                  </div>
                </Col>
              ))}
          </Row>
        </Col>
      </Row>
      <Loader isLoading={loading} />
    </div>
  );
};

export default DelegateAccess;
